// Copyright (c) 2016 Deere & Company

import PipProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/pip-product-search-results';
import t from 'tcomb';

const PipProducts = t.list(PipProductSearchResult, 'PipProducts');

export const getDefaultState = () => new PipProducts([]);

export default PipProducts;



// WEBPACK FOOTER //
// ./src/claim/pip/state/pip-products.js